import { render, staticRenderFns } from "./Core.vue?vue&type=template&id=3896af7e&"
import script from "./Core.vue?vue&type=script&lang=js&"
export * from "./Core.vue?vue&type=script&lang=js&"
import style0 from "./Core.vue?vue&type=style&index=0&id=3896af7e&prod&lang=scss&"
import style1 from "./Core.vue?vue&type=style&index=1&id=3896af7e&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports